export default "__VITE_ASSET__DqJLK_wg__"